/* eslint-disable no-irregular-whitespace */
<template>
  <div class="p-menu">
    <div class="l-container">
      <div class="c-box mb-12 mt-px">
        <SubHeaderMenu />
        <MenuNavigation />

        <div class="menu-main-content">
          <section>
            <div class="rate-feedback">
              <div class="rate text-center">
                <Rating style="display: contents !important" rate="3.5"/>
                <div class="mt-3">000 件の評価</div>
                <button class="c-btn btn-white mt-7">クチコミを投稿する</button>
              </div>
              <div>
                <a-divider vertical class="w-1/6 h-full sm:hidden" />
              </div>
              <div class="rate-result">
                <div class="font-bold">顧客満足度</div>
                <RateResult class="mt-2" v-for="(el, i) in rateData" :key="i"  :text="el.text" :percent_rate="el.precent" :number_percent="el.number_percent" />
              </div>
            </div>
          </section>

          <div class="pagination justify-between mt-12">
            <div class="w-3/4 sm:w-full flex items-center">
              <strong>18</strong>件中 1～10件表示
              <Pagination class="w-2/4 sm:w-full flex justify-center sm:hidden" page="1"
              />
            </div>
            <div class="flex sm:hidden">
              <a-select v-model="value" :options="options" />
            </div>
          </div>
          
          <section>
            <div>
              <Comment :editable="true" :post_type="false" />
              <Comment :post_type="true" />
              <Comment :post_type="true" />
              <Comment :post_type="true" />
              <Comment :post_type="true" />
              <Comment :post_type="true" />
            </div>
          </section>

          <div class="pagination justify-between mb-8">
            <div class="w-3/4 sm:w-full sub-item items-center">
              <div class="flex"><strong class="mr-2">18</strong>件中 1～10件表示</div>
              <Pagination class="w-2/4 sm:w-full flex justify-center" page="1" />
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {
  SubHeaderMenu,
  MenuNavigation
} from '@/components/compound'
import { Rating, Pagination } from '@/components/primitive'
import RateResult from './components/RateResults'
import Comment from './components/Comment'

export default {
  components: {
    SubHeaderMenu,
    MenuNavigation,
    Pagination,
    Rating,
    RateResult,
    Comment
  },
  data() {
    return {
      rateData: [
        {
          text: '星5つ',
          precent: 'percent-100',
          number_percent: '100'
        },
        {
          text: '星4つ',
          precent: 'percent-80',
          number_percent: '80'
        },
        {
          text: '星3つ',
          precent: 'percent-60',
          number_percent: '60'
        },
        {
          text: '星2つ',
          precent: 'percent-40',
          number_percent: '40'
        },
        {
          text: '星1つ',
          precent: 'percent-20',
          number_percent: '20'
        }
      ],
      value: '新着順',
      options: [
        {
          label: '新着順',
          value: '新着順'
        }
      ],
      breadcrumb_data: ['トップ', '旅・宿泊', '国内宿泊', '宿泊施設名宿泊施設名宿泊施設名'],
      open: false
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
